// Alyviu product page
const STAR_PATH = 'M12 2.6l2.84 6.02 6.56.86-4.8 4.56 1.2 6.52L12 17.4l-5.8 3.16 1.2-6.52-4.8-4.56 6.56-.86z';
const ARROW_PREV =
  '<svg viewBox="0 0 6 10" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" d="M5 1 1 5l4 4"/></svg>';
const ARROW_NEXT =
  '<svg viewBox="0 0 6 10" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" d="m1 1 4 4-4 4"/></svg>';
const PIN =
  '<svg viewBox="0 0 16 16" aria-hidden="true"><path fill="currentColor" d="M5 1h6v1.5h-1V7l2 2.2V10.5H8.75V15h-1.5v-4.5H4V9.2L6 7V2.5H5z"/></svg>';

const rootUrl = () => window.Shopify?.routes?.root || '/';

function el(tag, className, text) {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text != null) node.textContent = text;
  return node;
}

function starsHtml(rating) {
  let html = '';
  for (let i = 1; i <= 5; i++) {
    const fill = i <= rating ? 'currentColor' : 'none';
    html += `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${STAR_PATH}" fill="${fill}" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>`;
  }
  return html;
}

/* ---------- Gallery ---------- */
function initGallery(gallery) {
  const viewport = gallery.querySelector('[data-aly-viewport]');
  const slides = [...gallery.querySelectorAll('[data-aly-slide]')];
  const thumbs = [...gallery.querySelectorAll('[data-aly-thumb]')];
  const thumbStrip = gallery.querySelector('[data-aly-thumbs]');
  const prev = gallery.querySelector('[data-aly-gal-prev]');
  const next = gallery.querySelector('[data-aly-gal-next]');
  if (!viewport || slides.length === 0) return;
  let index = 0;

  const setActive = (i) => {
    if (i === index) return;
    slides[index]?.querySelector('video')?.pause();
    index = i;
    thumbs.forEach((thumb, n) => thumb.classList.toggle('is-active', n === i));
    const thumb = thumbs[i];
    if (thumb && thumbStrip) {
      const left = thumb.offsetLeft - thumbStrip.offsetLeft - (thumbStrip.clientWidth - thumb.clientWidth) / 2;
      thumbStrip.scrollTo({ left, behavior: 'smooth' });
    }
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i === slides.length - 1;
  };

  const goTo = (i) => {
    const target = Math.max(0, Math.min(slides.length - 1, i));
    viewport.scrollTo({ left: target * viewport.clientWidth, behavior: 'smooth' });
  };

  let ticking = false;
  viewport.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        setActive(Math.round(viewport.scrollLeft / viewport.clientWidth));
      });
    },
    { passive: true }
  );
  thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => goTo(i)));
  prev?.addEventListener('click', () => goTo(index - 1));
  next?.addEventListener('click', () => goTo(index + 1));
}

/* ---------- Rotators ---------- */
function initTestimonials(box) {
  const items = [...box.querySelectorAll('.aly-avis__item')];
  if (items.length < 2) return;
  const delay = Number(box.dataset.delay) || 8000;
  let index = 0;
  let timer;
  const show = (i) => {
    items[index].classList.remove('is-active');
    index = (i + items.length) % items.length;
    items[index].classList.add('is-active');
  };
  const start = () => {
    clearInterval(timer);
    timer = setInterval(() => show(index + 1), delay);
  };
  box.querySelectorAll('[data-dir]').forEach((button) =>
    button.addEventListener('click', () => {
      show(index + Number(button.dataset.dir));
      start();
    })
  );
  start();
}

function initSnippets(box) {
  const track = box.querySelector('[data-aly-track]');
  const count = track ? track.children.length : 0;
  if (count < 2) return;
  const delay = Number(box.dataset.delay) || 5000;
  let index = 0;
  let timer;
  const show = (i) => {
    index = (i + count) % count;
    track.style.transform = `translateX(-${index * 100}%)`;
  };
  const start = () => {
    clearInterval(timer);
    timer = setInterval(() => show(index + 1), delay);
  };
  box.querySelectorAll('[data-dir]').forEach((button) =>
    button.addEventListener('click', () => {
      show(index + Number(button.dataset.dir));
      start();
    })
  );
  box.addEventListener('pointerenter', () => clearInterval(timer));
  box.addEventListener('pointerleave', start);
  start();
}

/* ---------- Offers, add to cart, sticky bar ---------- */
function initHero(hero) {
  const form = hero.querySelector('[data-aly-form]');
  const button = hero.querySelector('[data-aly-atc]');
  const cta = hero.querySelector('[data-aly-cta]');
  const error = hero.querySelector('[data-aly-error]');
  const offers = [...hero.querySelectorAll('[data-aly-offer]')];

  const syncOffers = () => {
    offers.forEach((offer) => {
      const selected = offer.querySelector('input').checked;
      offer.classList.toggle('is-selected', selected);
      if (!selected) return;
      if (cta && offer.dataset.cta) cta.textContent = offer.dataset.cta;
      const price = hero.querySelector('[data-aly-price]');
      const compare = hero.querySelector('[data-aly-compare]');
      if (price && offer.dataset.price) price.textContent = offer.dataset.price;
      if (compare && offer.dataset.compare) compare.textContent = offer.dataset.compare;
      const save = hero.querySelector('[data-aly-save]');
      if (save && offer.dataset.save) save.textContent = `\u2212${offer.dataset.save}\u00a0%`;
    });
  };
  offers.forEach((offer) => offer.querySelector('input').addEventListener('change', syncOffers));
  syncOffers();

  const showError = (message) => {
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  };

  const addToCart = async () => {
    const cartUrl = `${rootUrl()}cart`;
    const body = new FormData(form);
    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((item) => item.dataset.sectionId)
      .filter(Boolean);
    if (sectionIds.length) body.append('sections', sectionIds.join(','));

    // The theme's cart drawer listens to Shopify's standard cart event. Without it, go to the cart page.
    let events = null;
    if (document.querySelector('cart-drawer-component')) {
      try {
        events = await import('@shopify/events');
      } catch (_) {
        events = null;
      }
    }
    const UpdateEvent = events?.CartLinesUpdateEvent;
    const deferred = UpdateEvent?.createPromise?.();
    if (deferred) {
      form.dispatchEvent(
        new UpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(body.get('id')), quantity: 1 }],
          promise: deferred.promise,
        })
      );
    }

    const fetchCart = () =>
      fetch(`${cartUrl}.json`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((r) =>
        r.json()
      );
    const settle = (cart, detail) =>
      deferred.resolve({
        cart: UpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'product-form-component',
          sourceId: form.id,
          itemCount: 1,
          productId: form.querySelector('[name="product-id"]')?.value,
          ...detail,
        },
      });

    try {
      const response = await fetch(`${cartUrl}/add.js`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body,
      }).then((r) => r.json());

      if (response.status) {
        showError(response.description || response.message);
        if (deferred) settle(await fetchCart(), { didError: true });
        return;
      }
      showError('');
      document.dispatchEvent(new CustomEvent('alyviu:added-to-cart', { detail: { item: response } }));
      if (!deferred) {
        window.location.assign(cartUrl);
        return;
      }
      settle(await fetchCart(), { sections: response.sections, didError: false });
    } catch (err) {
      deferred?.reject(err);
      form.submit();
    }
  };

  let busy = false;
  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (busy) return;
    busy = true;
    button?.setAttribute('aria-busy', 'true');
    try {
      await addToCart();
    } finally {
      busy = false;
      button?.removeAttribute('aria-busy');
    }
  });

  const sticky = hero.querySelector('[data-aly-sticky]');
  const buy = hero.querySelector('[data-aly-buy]');
  if (sticky && buy) {
    const stickyButton = sticky.querySelector('[data-aly-sticky-btn]');
    stickyButton?.addEventListener('click', () => form?.requestSubmit());
    new IntersectionObserver(([entry]) => {
      const passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      sticky.classList.toggle('is-visible', passed);
      sticky.setAttribute('aria-hidden', String(!passed));
      if (stickyButton) stickyButton.tabIndex = passed ? 0 : -1;
    }).observe(buy);
  }
}

/* ---------- Reviews ---------- */
async function initReviews(root) {
  const list = root.querySelector('[data-aly-list]');
  const pages = root.querySelector('[data-aly-pages]');
  const photos = root.querySelector('[data-aly-photos]');
  const box = root.querySelector('[data-aly-box]');
  const filterButton = root.querySelector('[data-aly-filter-btn]');
  const sortButton = root.querySelector('[data-aly-sort-btn]');
  const filterMenu = root.querySelector('[data-aly-filter-menu]');
  const sortMenu = root.querySelector('[data-aly-sort-menu]');
  const perPage = Number(root.dataset.perPage) || 5;
  const base = root.dataset.assetBase || '';
  const labels = root.dataset;
  const sortLabels = (labels.labelSorts || '').split('|');

  let reviews = [];
  try {
    reviews = await fetch(root.dataset.src).then((r) => r.json());
  } catch (_) {
    return;
  }
  reviews.forEach((review, i) => (review.i = i));
  const state = { page: 1, sort: 0, filter: 0 };

  const hist = root.querySelector('[data-aly-hist]');
  if (hist) {
    const starLabels = (labels.labelStars || '').split('|');
    [5, 4, 3, 2, 1].forEach((n) => {
      const count = reviews.filter((review) => review.r === n).length;
      const row = el('div', 'aly-rev__bar');
      const track = el('i');
      const fill = el('b');
      fill.style.width = `${reviews.length ? (count / reviews.length) * 100 : 0}%`;
      track.append(fill);
      row.append(el('span', '', `${n} ${starLabels[n === 1 ? 0 : 1] || starLabels[0] || ''}`), track, el('span', '', String(count)));
      hist.append(row);
    });
  }

  const openPhoto = (src) => {
    let img = box.querySelector('img');
    if (!img) {
      img = el('img');
      img.alt = '';
      box.append(img);
    }
    img.src = src;
    box.hidden = false;
  };
  box.addEventListener('click', (event) => {
    if (event.target.tagName !== 'IMG') box.hidden = true;
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') box.hidden = true;
  });

  const photoButton = (file, size) => {
    const button = el('button');
    button.type = 'button';
    const img = el('img');
    img.src = base + file;
    img.alt = '';
    img.loading = 'lazy';
    img.width = size;
    img.height = size;
    button.append(img);
    button.addEventListener('click', () => openPhoto(base + file));
    return button;
  };

  reviews.forEach((review) => (review.p || []).forEach((file) => photos.append(photoButton(file, 100))));
  if (photos.children.length < 3) photos.hidden = true;

  const clampable = (node, moreLabel, lessLabel) => {
    node.classList.add('is-clamped');
    requestAnimationFrame(() => {
      if (node.scrollHeight <= node.clientHeight + 2) {
        node.classList.remove('is-clamped');
        return;
      }
      const toggle = el('button', 'aly-rev__more', moreLabel);
      toggle.type = 'button';
      toggle.addEventListener('click', () => {
        const clamped = node.classList.toggle('is-clamped');
        toggle.textContent = clamped ? moreLabel : lessLabel;
      });
      node.after(toggle);
    });
  };

  const renderReview = (review) => {
    const item = el('article', 'aly-rev__item');
    const row = el('div', 'aly-rev__row');
    const stars = el('span', 'aly-stars');
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', `${review.r} / 5`);
    stars.innerHTML = starsHtml(review.r);
    row.append(stars);
    if (review.k) {
      const pin = el('span', 'aly-rev__pin');
      pin.innerHTML = PIN;
      row.append(pin);
    }
    const who = el('div', 'aly-rev__who');
    who.append(el('span', 'aly-rev__avatar', (review.n || '?').trim().charAt(0)), el('span', 'aly-rev__name', review.n));
    item.append(row, who);
    if (review.t) item.append(el('h3', 'aly-rev__head', review.t));
    const body = el('div', 'aly-rev__body');
    body.style.whiteSpace = 'pre-line';
    body.textContent = review.b;
    item.append(body);
    clampable(body, labels.labelMore, labels.labelLess);
    if (review.p?.length) {
      const pics = el('div', 'aly-rev__pics');
      review.p.forEach((file) => pics.append(photoButton(file, 160)));
      item.append(pics);
    }
    if (review.y) {
      const reply = el('div', 'aly-rev__reply');
      const replyBody = el('div', 'aly-rev__reply-body');
      replyBody.style.whiteSpace = 'pre-line';
      replyBody.textContent = review.y;
      reply.append(el('p', 'aly-rev__reply-by', labels.labelReply), replyBody);
      item.append(reply);
      clampable(replyBody, labels.labelMore, labels.labelLess);
    }
    return item;
  };

  const current = () => {
    let rows = state.filter ? reviews.filter((review) => review.r === state.filter) : reviews.slice();
    if (state.sort === 1) rows.sort((a, b) => (a.d < b.d ? 1 : a.d > b.d ? -1 : a.i - b.i));
    if (state.sort === 2) rows.sort((a, b) => b.r - a.r || a.i - b.i);
    if (state.sort === 3) rows.sort((a, b) => a.r - b.r || a.i - b.i);
    return rows;
  };

  const pageButton = (label, page, options = {}) => {
    const button = el('button');
    button.type = 'button';
    if (options.html) button.innerHTML = label;
    else button.textContent = label;
    if (options.aria) button.setAttribute('aria-label', options.aria);
    if (options.current) button.setAttribute('aria-current', 'page');
    if (options.disabled) button.disabled = true;
    button.addEventListener('click', () => {
      state.page = page;
      render(true);
    });
    return button;
  };

  const render = (scroll) => {
    const rows = current();
    const total = Math.max(1, Math.ceil(rows.length / perPage));
    state.page = Math.min(state.page, total);
    list.replaceChildren(
      ...(rows.length
        ? rows.slice((state.page - 1) * perPage, state.page * perPage).map(renderReview)
        : [el('p', 'aly-rev__empty', labels.labelEmpty)])
    );

    pages.replaceChildren();
    if (total > 1) {
      const shown = new Set([1, total, state.page - 1, state.page, state.page + 1]);
      if (state.page <= 3) [2, 3, 4].forEach((n) => shown.add(n));
      if (state.page >= total - 2) [total - 3, total - 2, total - 1].forEach((n) => shown.add(n));
      const numbers = [...shown].filter((n) => n >= 1 && n <= total).sort((a, b) => a - b);
      pages.append(pageButton(ARROW_PREV, state.page - 1, { html: true, aria: '‹', disabled: state.page === 1 }));
      numbers.forEach((n, i) => {
        if (i && n - numbers[i - 1] > 1) pages.append(el('span', '', '…'));
        pages.append(pageButton(String(n), n, { current: n === state.page }));
      });
      pages.append(pageButton(ARROW_NEXT, state.page + 1, { html: true, aria: '›', disabled: state.page === total }));
    }
    if (scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const buildMenu = (menu, options, key) => {
    menu.replaceChildren(
      ...options.map(({ label, value, note }) => {
        const button = el('button');
        button.type = 'button';
        button.append(el('span', '', label));
        if (note != null) button.append(el('small', '', String(note)));
        button.setAttribute('aria-pressed', String(state[key] === value));
        button.addEventListener('click', () => {
          state[key] = value;
          state.page = 1;
          menu.hidden = true;
          buildMenus();
          render(false);
        });
        return button;
      })
    );
  };
  const buildMenus = () => {
    buildMenu(
      filterMenu,
      [
        { label: labels.labelAll, value: 0, note: reviews.length },
        ...[5, 4, 3, 2, 1].map((n) => ({
          label: `${n} ${(labels.labelStars || '').split('|')[n === 1 ? 0 : 1] || labels.labelStars}`,
          value: n,
          note: reviews.filter((review) => review.r === n).length,
        })),
      ],
      'filter'
    );
    buildMenu(
      sortMenu,
      sortLabels.map((label, value) => ({ label, value })),
      'sort'
    );
  };
  const toggleMenu = (button, menu, other) => {
    button.addEventListener('click', (event) => {
      event.stopPropagation();
      other.hidden = true;
      menu.hidden = !menu.hidden;
      button.setAttribute('aria-expanded', String(!menu.hidden));
    });
  };
  toggleMenu(filterButton, filterMenu, sortMenu);
  toggleMenu(sortButton, sortMenu, filterMenu);
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.aly-rev__menu')) {
      filterMenu.hidden = true;
      sortMenu.hidden = true;
    }
  });

  buildMenus();
  render(false);
}

/* ---------- Section videos: only fetched when they get close to the screen ---------- */
function initLazyVideo(video) {
  const start = () => {
    video.preload = 'auto';
    video.play().catch(() => {});
  };
  if (!('IntersectionObserver' in window)) {
    start();
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      io.disconnect();
      start();
    },
    { rootMargin: '600px 0px' }
  );
  io.observe(video);
}

function init() {
  const once = (selector, fn) =>
    document.querySelectorAll(selector).forEach((node) => {
      if (node.dataset.alyReady) return;
      node.dataset.alyReady = '1';
      fn(node);
    });
  once('[data-aly-gallery]', initGallery);
  once('[data-aly-avis]', initTestimonials);
  once('[data-aly-snip]', initSnippets);
  once('[data-aly-hero]', initHero);
  once('[data-aly-reviews]', initReviews);
  once('[data-aly-lazy-video]', initLazyVideo);
}

init();
document.addEventListener('DOMContentLoaded', init);
document.addEventListener('shopify:section:load', init);

/* ---------- PDP (17/out): data de despacho + país do visitante (bandeira, "Fast XX Shipping", "to Country") ---------- */
(function () {
  var rows = Array.prototype.slice.call(document.querySelectorAll('[data-aly-ship]'));
  var names = Array.prototype.slice.call(document.querySelectorAll('[data-aly-country]'));
  if (!rows.length && !names.length) return;
  rows.forEach(function (row) {
    var d = new Date(), days = parseInt(row.getAttribute('data-days'), 10) || 2, added = 0;
    while (added < days) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) added++; }
    var el = row.querySelector('[data-aly-ship-date]');
    if (el) el.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  });
  var apply = function (code, name) {
    if (!code) return;
    code = String(code).toUpperCase();
    rows.forEach(function (row) {
      var flag = row.querySelector('[data-aly-ship-flag]'), fast = row.querySelector('[data-aly-ship-fast]');
      if (flag) { flag.onload = function () { flag.hidden = false; }; flag.alt = name || code; flag.src = 'https://cdn.shopify.com/static/images/flags/' + code.toLowerCase() + '.svg'; }
      if (fast) fast.textContent = 'Fast ' + code + ' Shipping';
    });
    if (name) names.forEach(function (n) { n.textContent = name; });
  };
  var cached = null;
  try { cached = JSON.parse(sessionStorage.getItem('adv_country') || 'null'); } catch (e) {}
  if (cached && cached.handle) { apply(cached.handle, cached.name); return; }
  if (rows[0] && rows[0].getAttribute('data-cc')) apply(rows[0].getAttribute('data-cc'), rows[0].getAttribute('data-cname'));
  fetch('/browsing_context_suggestions.json', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (j) {
      var c = j && j.detected_values && j.detected_values.country;
      if (!c || !c.handle) return;
      try { sessionStorage.setItem('adv_country', JSON.stringify(c)); } catch (e) {}
      apply(c.handle, c.name);
    })
    .catch(function () {});
})();

